"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _reactHelmet = require("react-helmet");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var generateBreadcrumbContent = function generateBreadcrumbContent(data, schema) {
  var domain = typeof window !== 'undefined' && window.origin ? window.origin : '__DOMAIN_URL__';
  var itemList = [];
  {
    data.map(function (link, idx) {
      return itemList.push({
        '@type': 'ListItem',
        position: idx + 1,
        name: link.label,
        item: "" + domain + link.url
      });
    });
  }
  schema['itemListElement'] = itemList;
  return {
    isSchemaApplicable: data && data.length > 0,
    result: schema
  };
};
var generateFaqPageContent = function generateFaqPageContent(data, schema) {
  var mainEntity = [];
  {
    data.map(function (question, idx) {
      return mainEntity.push({
        '@type': 'Question',
        name: question.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: "" + question.answer + question.additionalDescription
        }
      });
    });
  }
  schema['mainEntity'] = mainEntity;
  return {
    isSchemaApplicable: data && data.length > 0,
    result: schema
  };
};
var generateProductContent = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(data, schema) {
    var jsonLDData, _feefoDataJson$rating, _feefoDataJson$rating2, _feefoDataJson$rating3, aggregateRating, feefoData, feefoDataJson;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            jsonLDData = data && data.jsonLDData ? JSON.parse(data.jsonLDData) : null;
            if (!jsonLDData) {
              _context.next = 11;
              break;
            }
            _context.next = 4;
            return fetch("https://api.feefo.com/api/10/reviews/summary/product?since_period=YEAR&unanswered_feedback=include&source=on_page_product_integration&product_sku=" + data.productSkuId + "&merchant_identifier=mitsubishi-ca-en&origin=www.mitsubishi-motors.ca");
          case 4:
            feefoData = _context.sent;
            _context.next = 7;
            return feefoData.json();
          case 7:
            feefoDataJson = _context.sent;
            aggregateRating = {
              '@type': 'AggregateRating',
              ratingValue: (_feefoDataJson$rating = feefoDataJson.rating) == null ? void 0 : _feefoDataJson$rating.rating,
              ratingCount: (_feefoDataJson$rating2 = feefoDataJson.rating) == null ? void 0 : (_feefoDataJson$rating3 = _feefoDataJson$rating2.product) == null ? void 0 : _feefoDataJson$rating3.count
            };
            schema['aggregateRating'] = aggregateRating;
            return _context.abrupt("return", {
              isSchemaApplicable: data && data.jsonLDData ? true : false,
              result: _objectSpread(_objectSpread(_objectSpread({}, schema), JSON.parse(data.jsonLDData)), {}, {
                '@type': [schema['@type']],
                image: jsonLDData.image ? "" + window.origin + jsonLDData.image : ''
              })
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function generateProductContent(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var generateBlogContent = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(data) {
    var jsonLDBlogData, datePublished, utcString;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            jsonLDBlogData = data && data.jsonLDBlogData ? JSON.parse(data.jsonLDBlogData) : null;
            if (!jsonLDBlogData) {
              _context2.next = 7;
              break;
            }
            datePublished = jsonLDBlogData.datePublished;
            utcString = new Date(datePublished).toISOString(); // Update the publisher logo URL
            if (jsonLDBlogData.publisher && jsonLDBlogData.publisher.logo) {
              jsonLDBlogData.publisher.logo.url = "" + window.origin + jsonLDBlogData.publisher.logo.url;
            }

            // Update the id
            if (jsonLDBlogData.mainEntityOfPage && jsonLDBlogData.mainEntityOfPage['@id']) {
              jsonLDBlogData.mainEntityOfPage['@id'] = "" + window.origin + jsonLDBlogData.mainEntityOfPage['@id'];
            }
            return _context2.abrupt("return", {
              isSchemaApplicable: true,
              result: _objectSpread(_objectSpread(_objectSpread({}, jsonLDBlogData), {
                datePublished: utcString
              }), {
                image: jsonLDBlogData.image ? "" + window.origin + jsonLDBlogData.image : ''
              })
            });
          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function generateBlogContent(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var generateNewsContent = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(data) {
    var jsonLDNewsData, datePublished, utcString;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            jsonLDNewsData = data && data.jsonLDNewsData ? JSON.parse(data.jsonLDNewsData) : null;
            if (!jsonLDNewsData) {
              _context3.next = 7;
              break;
            }
            datePublished = jsonLDNewsData.datePublished;
            utcString = new Date(datePublished).toISOString(); // Update the publisher logo URL
            if (jsonLDNewsData.publisher && jsonLDNewsData.publisher.logo) {
              jsonLDNewsData.publisher.logo.url = "" + window.origin + jsonLDNewsData.publisher.logo.url;
            }

            // Update the id
            if (jsonLDNewsData.mainEntityOfPage && jsonLDNewsData.mainEntityOfPage['@id']) {
              jsonLDNewsData.mainEntityOfPage['@id'] = "" + window.origin + jsonLDNewsData.mainEntityOfPage['@id'];
            }
            return _context3.abrupt("return", {
              isSchemaApplicable: true,
              result: _objectSpread(_objectSpread(_objectSpread({}, jsonLDNewsData), {
                datePublished: utcString
              }), {
                image: jsonLDNewsData.image ? "" + window.origin + jsonLDNewsData.image : ''
              })
            });
          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function generateNewsContent(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

/* Mapping function  to map schema type with corresponding generateschema functions */
var schemaGeneratorMap = {
  BreadcrumbList: generateBreadcrumbContent,
  FAQPage: generateFaqPageContent,
  Product: generateProductContent,
  Blog: generateBlogContent,
  News: generateNewsContent
};
var StructuredData = function StructuredData(_ref4) {
  var data = _ref4.data,
    schemaType = _ref4.schemaType;
  var _useState = (0, _react.useState)(false),
    isSchemaApplicable = _useState[0],
    setIsSchemaApplicable = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    result = _useState2[0],
    setResult = _useState2[1];
  var schema = {};
  schema['@context'] = 'https://schema.org';
  schema['@type'] = schemaType;
  var schemaGeneratorFunc = schemaGeneratorMap[schemaType];
  var resp = schemaGeneratorFunc(data, schema);
  (0, _react.useEffect)(function () {
    function updateSchema(_x5, _x6) {
      return _updateSchema.apply(this, arguments);
    }
    function _updateSchema() {
      _updateSchema = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(data, schema) {
        var _yield$schemaGenerato, _result, _isSchemaApplicable;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return schemaGeneratorFunc(data, schema);
              case 3:
                _yield$schemaGenerato = _context4.sent;
                _result = _yield$schemaGenerato.result;
                _isSchemaApplicable = _yield$schemaGenerato.isSchemaApplicable;
                setIsSchemaApplicable(_isSchemaApplicable);
                setResult(_result);
                _context4.next = 12;
                break;
              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[0, 10]]);
      }));
      return _updateSchema.apply(this, arguments);
    }
    updateSchema(data, schema);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isSchemaApplicable && /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, {
    encodeSpecialCharacters: false
  }, /*#__PURE__*/_react["default"].createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(result))));
};
var _default = StructuredData;
exports["default"] = _default;